import React from "react";
import { Button, IconButton, Modal } from "@ilc-technology/luik";
import { useDatasources } from "../../contexts/StoryblokContext/StoryblokContext";
import { LabelKey } from "../../Common/StoryblokTypes";

interface UpgradeModalProps {
  isOpen: boolean;
  isDismissable?: boolean;
  isSaving: boolean;
  isSavingDisabled: boolean;
  header: string;
  children: React.ReactNode;
  headerChildren: React.ReactNode;
  closeHandler: () => void;
  cancelHandler: () => void;
  upgradeHandler: () => void;
}

const UpgradeModal = ({
  isOpen,
  isDismissable,
  isSavingDisabled,
  isSaving,
  header,
  children: content,
  headerChildren,
  closeHandler,
  cancelHandler,
  upgradeHandler,
}: UpgradeModalProps) => {
  const { labels } = useDatasources();

  return (
    <Modal onClose={closeHandler} open={isOpen} isDismissable={isDismissable} className="max-w-[750px]">
      <IconButton
        aria-label="Close modal"
        className="absolute end-0 top-0 scale-95 border-0 md:end-3 md:top-3 md:scale-100"
        iconName="close"
        intent="primary-white"
        onPress={closeHandler}
        size="sm"
      />
      <Modal.Header className="px-8 py-3 text-center text-base text-label-md-bold md:px-16 md:py-6 md:text-xl">
        {header}
      </Modal.Header>

      <Modal.Content className="space-y-3 px-3 py-3 md:mx-10 md:space-y-6 md:px-6 md:py-6">
        <section className="mx-2 px-0 md:mx-4">{headerChildren}</section>
        {content}
      </Modal.Content>

      <Modal.Footer className="mx-0 mt-10 flex justify-between px-6 py-6 md:px-10 md:py-6 ">
        <Button intent="secondary-black" onPress={cancelHandler}>
          {labels[LabelKey.cancel]}
        </Button>
        <Button
          intent="primary-black"
          data-testid="upgrade-button"
          isLoading={isSaving}
          isDisabled={isSavingDisabled}
          onPress={upgradeHandler}
        >
          {labels[LabelKey.upgrade]}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default UpgradeModal;
